import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeM from '../views/gb/mobile.vue'
import Home from '../views/home.vue'
import GbwappsArticle from '../views/GbwappsArticle.vue'
import { articlePages, site, homePage } from '../documents/gbwappsPages'
// import UAParser from 'ua-parser-js';
// const uaParser = new UAParser();
// const deviceInfo = uaParser.getResult();

// const isMobileDevice = deviceInfo.device.type === 'mobile';
Vue.use(VueRouter)

/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 开始 */
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 结束 */

export const constRoutesPc = [
	{
		path: '/',
		name: 'en-gb',
		meta: {
			appname: site.name,
			title: homePage.hero.title,
			keywords: 'gbwhatsapp, gb whatsapp, gb whatsapp download, gb whatsapp apk',
			description: `Download GBWhatsApp APK for Android and learn how to install, update, backup, restore, and use GB WhatsApp safely.`,
			link: [
				{
					rel: 'canonical',
					href: `${site.domain}/`
				}
			]
		},
		component: Home,
	},
	{
		path: '/download/',
		name: 'en-download',
		meta: {
			appname: site.name,
			pageKey: 'download',
			title: articlePages.download.title,
			keywords: 'gbwhatsapp apk download, gb whatsapp apk download, gbwhatsapp download, gb whatsapp download',
			description: `Safe page to download GB WhatsApp APK with simple install steps and important notes before installing on Android.`,
			link: [
				{
					rel: 'canonical',
					href: `${site.domain}/download/`
				}
			]
		},
		component: GbwappsArticle,
	},
	{
		path: '/blue-whatsapp-plus-apk/',
		name: 'en-blue-whatsapp-plus',
		meta: {
			appname: site.name,
			pageKey: 'blue',
			title: articlePages.blue.title,
			keywords: 'blue whatsapp plus apk, blue whatsapp apk, blue whatsapp plus download',
			description: `Download Blue WhatsApp Plus APK for Android and learn features, install steps, specifications, and safety notes.`,
			link: [{ rel: 'canonical', href: `${site.domain}/blue-whatsapp-plus-apk/` }]
		},
		component: GbwappsArticle,
	},
	{
		path: '/fouad-whatsapp-apk/',
		name: 'en-fouad-whatsapp',
		meta: {
			appname: site.name,
			pageKey: 'fouad',
			title: articlePages.fouad.title,
			keywords: 'fouad whatsapp apk, fouad whatsapp download, fouad wa apk',
			description: `Download Fouad WhatsApp APK v10.10 and read features, Android requirements, install steps, and update notes.`,
			link: [{ rel: 'canonical', href: `${site.domain}/fouad-whatsapp-apk/` }]
		},
		component: GbwappsArticle,
	},
	{
		path: '/aerowhatsapp-apk/',
		name: 'en-aero-whatsapp',
		meta: {
			appname: site.name,
			pageKey: 'aero',
			title: articlePages.aero.title,
			keywords: 'aero whatsapp apk, aerowhatsapp apk, whatsapp aero download',
			description: `Download Aero WhatsApp APK for Android and compare features, requirements, install steps, and GB WhatsApp differences.`,
			link: [{ rel: 'canonical', href: `${site.domain}/aerowhatsapp-apk/` }]
		},
		component: GbwappsArticle,
	},
	{
		path: '/gbwhatsapp-old-version-apk/',
		name: 'en-gbwhatsapp-old-version',
		meta: {
			appname: site.name,
			pageKey: 'old',
			title: articlePages.old.title,
			keywords: 'gb whatsapp old version, gb whatsapp old version download, gb whatsapp previous version, gb whatsapp older apk',
			description: `Find why users download GB WhatsApp old versions such as v18.50 and v18.40, plus safety notes before installing older APK files.`,
			link: [{ rel: 'canonical', href: `${site.domain}/gbwhatsapp-old-version-apk/` }]
		},
		component: GbwappsArticle,
	},
	{
		path: '/about-us/',
		name: 'en-about-us',
		meta: {
			appname: site.name,
			pageKey: 'about',
			title: 'About Us - Information & Tutorial Website',
			description: `About GBWApps: an independent informational website for GB WhatsApp guides, tutorials, and educational content.`,
			link: [{ rel: 'canonical', href: `${site.domain}/about-us/` }]
		},
		component: GbwappsArticle,
	},
	{
		path: '/contact-us/',
		name: 'en-contact-us',
		meta: {
			appname: site.name,
			pageKey: 'contact',
			title: 'Contact Us - Get in Touch',
			description: `Contact GBWApps for general website questions. We share information only and do not provide app technical support.`,
			link: [{ rel: 'canonical', href: `${site.domain}/contact-us/` }]
		},
		component: GbwappsArticle,
	},
	{
		path: '/privacy-policy/',
		name: 'en-privacy-policy',
		meta: {
			appname: site.name,
			pageKey: 'privacy',
			title: 'Privacy Policy - User Data & Cookies',
			description: `Privacy Policy for GBWApps, including cookies, analytics, third-party services, and how we handle visitor data.`,
			link: [{ rel: 'canonical', href: `${site.domain}/privacy-policy/` }]
		},
		component: GbwappsArticle,
	},
	{
		path: '/terms-conditions/',
		name: 'en-terms-conditions',
		meta: {
			appname: site.name,
			pageKey: 'terms',
			title: 'Terms & Conditions - Website Usage Policy',
			description: `Terms and Conditions for using GBWApps. All content is for informational and educational purposes only.`,
			link: [{ rel: 'canonical', href: `${site.domain}/terms-conditions/` }]
		},
		component: GbwappsArticle,
	},
	{
		path: '/disclaimer/',
		name: 'en-disclaimer',
		meta: {
			appname: site.name,
			pageKey: 'disclaimer',
			title: 'Disclaimer - Important Legal Notice',
			description: `GBWApps disclaimer: independent informational platform, not affiliated with WhatsApp LLC or Meta.`,
			link: [{ rel: 'canonical', href: `${site.domain}/disclaimer/` }]
		},
		component: GbwappsArticle,
	},

]


let routes = []
// if (isMobileDevice) {
// 	routes = constRoutesM
// }
// if (!isMobileDevice) {
// 	routes = constRoutesPc
// }

routes = constRoutesPc
export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
}
